/* eslint-disable react/prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import ManagerItem from '../ManagerItem/ManagerItem';
import './ManagerList.scss';

export default function ManagerList({ managerData }) {
  const { t } = useTranslation('not_found_messages');
  // Перший у списку (найменший id) — президент, він стоїть окремим рядком зверху
  const [president, ...vicePresidents] = managerData;

  return (
    <>
      {
        managerData.length > 0 && (
          <div className="manager-list">
            <div className="manager-list__row">
              <ManagerItem data={president} />
            </div>
            {
              vicePresidents.length > 0 && (
                <div className="manager-list__row">
                  {
                    vicePresidents.map((managerItem) => (
                      <ManagerItem
                        key={uuidv4()}
                        data={managerItem}
                      />
                    ))
                  }
                </div>
              )
            }
          </div>
        )
      }
      {
        managerData.length === 0 && (
          <p className="managers-not-found">
            {t('managers_not_found')}
          </p>
        )
      }
    </>
  );
}
